<template>
    <div class="flex-auto text-center flex min-h-0">
        <div class="flex flex-col flex-auto justify-center items-center min-h-0 -mt-20">
            <div>
                <img src="@/assets/register/tanachat-logo.png" class="mx-auto img-h-56" alt=""/>
            </div>
            <div class="mt-10 mx-10 mb-8">
                <div class="font-main font-bold text-20 text-a-orange-f36e21 mb-2">
                    ยินดีต้อนรับ
                </div>
                <div class="text-14">
                    โปรดปิดหน้าต่างนี้เพื่อเริ่มใช้งาน
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    components: {

    },
    setup: function () {
    },
})
</script>

<style lang="scss" scoped>
.img-h-56{
    max-height: 56.4px;
}
</style>
